<template>
  <ProcessingBatchAddDialog
    :value="value"
    mode="edit"
    :record="record"
    :buying-station-id="buyingStationId"
    :used-purchase-orders="usedPurchaseOrders"
    @input="$emit('input', $event)"
    @save="$emit('save', $event)"
    @close="$emit('close')"
  />
</template>

<script>
import ProcessingBatchAddDialog from "./AddDialog.vue";

export default {
  name: "ProcessingBatchEditDialog",
  components: { ProcessingBatchAddDialog },
  props: {
    value: { type: Boolean, default: false },
    record: { type: Object, default: null },
    buyingStationId: { type: [Number, String], default: null },
    usedPurchaseOrders: { type: Array, default: () => [] },
  },
};
</script>
